import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { CustomAttributeDefinition, FORM_MODE } from '../../CAD.types';
import { CADForm } from '../CADForm';

export interface CADEditMapProps {
	hasEntitlement: boolean;
	loading: boolean;
	definition: CustomAttributeDefinition;
}

export interface CADEditDispatchProps {
	fetchCustomAttribute: Function;
	onCancel: () => void;
	onSubmit: (id: string, definition: CustomAttributeDefinition) => void;
}

export type CADEditProps = CADEditMapProps & CADEditDispatchProps;

export function CADEdit({
	hasEntitlement,
	loading,
	fetchCustomAttribute,
	onCancel,
	onSubmit,
	definition,
}: CADEditProps) {
	const { id } = useParams();

	useEffect(() => {
		fetchCustomAttribute(id);
	}, [fetchCustomAttribute, id]);

	return (
		<CADForm
			mode={hasEntitlement ? FORM_MODE.EDIT : FORM_MODE.READ}
			definition={definition}
			loading={loading}
			onCancel={onCancel}
			onSubmit={(data: CustomAttributeDefinition) => onSubmit(id as string, data)}
		/>
	);
}

CADEdit.displayName = 'CADEdit';
